export default {
  blue: '#36B9D3',
  orange: '#F89E48',
  red: '#D60069',
  green: '#AEE94E',
  gray_100: '#C3CAD1'
}
